module.exports = __webpack_public_path__ + "static/media/closer.b828329f.png";